import { render } from "./StakingRewardsView.vue?vue&type=template&id=a4f0f414"
import script from "./StakingRewardsView.vue?vue&type=script&lang=js"
export * from "./StakingRewardsView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__